import React, { useState } from 'react'
import { navigate } from 'gatsby'
import useAuth from '../hooks/useAuth'

import '../pages/login.css'

const Login = ({ redirect }) => {
    const { state, login } = useAuth()
    const [identifier, setIdentifier] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const handleSubmit = async (event) => {
        event.preventDefault()
        try{
            await login({ identifier, password })
            navigate(redirect)
        }catch(e){
            console.log("Error occurred during register.")
            console.log(e)
            const { response: { data: { message: [{ messages: [error]}] } } } = e
            const { message: msg} = error
            setError(msg)
        }
    }

    return (
        <div>
            <form
                onSubmit={handleSubmit}
                >
                
                <div>
                    <input className="inbox"
                        placeholder="Username/Email" 
                        onChange={ e => {
                            setIdentifier(e.target.value)
                        }}
                        value={ identifier }
                        
                    />
                </div>
                <br/>
                <div>
                    <input type="password"
                        className="inbox"
                        placeholder="Password"
                        onChange={ e => {
                            setPassword(e.target.value)
                        }}
                        value={ password }
                        
                    />
                </div>
                <br/>
                <div>
                    <button id="subbut" type="submit">
                        <div id="subbox">Sign In</div>
                    </button>
                </div>
            </form> 
            { (error.length > 1) && (
                <p>{ error }</p>
            )}
        </div>  
    )
}

export default Login